import { Operation } from "reactcoregk";
import { EntityType } from "../@core/entityType";

export const entityType = EntityType.UserSettings;
export const entityOperations = [Operation.getAll];
